
import { Vue, Component, VModel, Prop } from 'vue-property-decorator'
import { observationIcons, severityColor } from '@/types/observation'

@Component({
    inheritAttrs: false,
})
export default class SeveritySelect extends Vue {
    @VModel() severity!: null | string | Array<string>
    @Prop({ default: false }) includeNull!: boolean

    severityColor = severityColor
    icon = observationIcons.severity

    get items() {
        const items = Object.keys(severityColor) as Array<any>
        if (this.includeNull) {
            items.push('null')
        }
        return items
    }

    itemTitle(val) {
        const translationKey = `observation_enums['observation.severity.${val}']`
        let text = this.$te(translationKey)
            ? this.$t(translationKey)
            : this.$t(`observation_fe['observations.filters.severity.${val}']`)

        return text
    }

    itemColor(val) {
        return severityColor[val] ? severityColor[val] : 'grey'
    }

    get multiple() {
        return Object.prototype.hasOwnProperty.call(this.$attrs, 'multiple')
    }

    remove(item) {
        if (this.lodash.isArray(this.severity)) {
            this.severity.splice(this.severity.indexOf(item), 1)
        }
    }

    handleNotSet(val) {
        if (this.lodash.isArray(this.severity)) {
            const lastAdded = val[val.length - 1]
            if (val.length > 1 && lastAdded == 'null') {
                this.severity = ['null']
            } else if (val.includes('null') && lastAdded != 'null') {
                this.severity = [lastAdded]
            }
        }
    }
}
